/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */

export default function _breadcrumbs() {
    const BREADCRUMB_PAGE_WIDTH_BREAKPOINT = 1200;

    const BREADCRUMB_SELECTOR = 'div.breadcrumb';

    const BREADCRUMB_LIST = 'ol.breadcrumb__list';

    const BREADCRUMB_LIST_ITEM = '.breadcrumb__list-item';

    const BREADCRUMB_LIST_ITEM_HOME_CLASS = 'breadcrumb__list-item-home';

    const BREADCRUMB_LIST_ITEM_ELLIPSIS_CLASS =
        'breadcrumb__list-item-ellipsis';

    const BREADCRUMB_LIST_ITEM_HIDDEN_CLASS = 'breadcrumb__list-item--hidden';

    const BREADCRUMB_ELLIPSIS_LINK = '.breadcrumb__list-item-link--ellipsis';

    class Breadcrumbs {
        constructor(breadcrumbs) {
            // outer wrapper for breadcrumbs
            this.breadcrumbs = breadcrumbs;
            this.breadcrumbItems =
                this.breadcrumbs.querySelectorAll(BREADCRUMB_LIST_ITEM);

            this.initEllipsis();
        }

        initEllipsis() {
            this.ellipsisShown = false;

            // grab the width of the breadcrumbs to test against in checkWidth
            this.allBreadcrumbWidth = 0;
            document
                .querySelectorAll(BREADCRUMB_LIST_ITEM)
                .forEach((listitem) => {
                    this.allBreadcrumbWidth += listitem.clientWidth;
                });

            // add click event to the ellipsis
            this.breadcrumbs
                .querySelector(BREADCRUMB_ELLIPSIS_LINK)
                .addEventListener('click', (event) => {
                    event.preventDefault();
                    this.removeEllipsis();
                });

            this.checkWidth();
            window.addEventListener('resize', () => {
                this.checkWidth();
            });
        }

        // checks the width of all the things to test wheather to show the ellipsis
        checkWidth() {
            const breadcrumbContainerWidth =
                document.querySelector(BREADCRUMB_LIST).clientWidth;

            if (
                window.innerWidth <= BREADCRUMB_PAGE_WIDTH_BREAKPOINT &&
                breadcrumbContainerWidth <= this.allBreadcrumbWidth
            ) {
                if (this.ellipsisShown === false) {
                    this.showEllipsis();
                }
            } else if (this.ellipsisShown === true) {
                this.removeEllipsis();
            }
        }

        showEllipsis() {
            this.ellipsisShown = true;
            // add event listener for ellipsis

            // add class to all list items for mobile

            this.breadcrumbItems.forEach((breadcrumbItem, index) => {
                if (
                    breadcrumbItem.classList.contains(
                        BREADCRUMB_LIST_ITEM_ELLIPSIS_CLASS
                    )
                ) {
                    breadcrumbItem.classList.remove(
                        BREADCRUMB_LIST_ITEM_HIDDEN_CLASS
                    );
                    breadcrumbItem
                        .querySelector('a')
                        .removeAttribute('tabindex');
                } else if (
                    !breadcrumbItem.classList.contains(
                        BREADCRUMB_LIST_ITEM_HOME_CLASS
                    ) &&
                    index !== this.breadcrumbItems.length - 1
                ) {
                    breadcrumbItem.classList.add(
                        BREADCRUMB_LIST_ITEM_HIDDEN_CLASS
                    );
                    breadcrumbItem
                        .querySelector('a')
                        .setAttribute('tabindex', '-1');
                }
            });
        }

        removeEllipsis() {
            this.ellipsisShown = false;
            this.breadcrumbItems.forEach((breadcrumbItem) => {
                breadcrumbItem.classList.remove(
                    BREADCRUMB_LIST_ITEM_HIDDEN_CLASS
                );
                const breadcrumbAnchor = breadcrumbItem.querySelector('a');
                if (breadcrumbAnchor !== null) {
                    breadcrumbAnchor.removeAttribute('tabindex');
                }
                if (
                    breadcrumbItem.classList.contains(
                        BREADCRUMB_LIST_ITEM_ELLIPSIS_CLASS
                    )
                ) {
                    breadcrumbItem.classList.add(
                        BREADCRUMB_LIST_ITEM_HIDDEN_CLASS
                    );
                    if (breadcrumbAnchor !== null) {
                        breadcrumbAnchor.setAttribute('tabindex', '-1');
                    }
                }
            });
        }
    }

    const breadcrumb = document.querySelector(BREADCRUMB_SELECTOR);

    if (!breadcrumb || breadcrumb.breadcrumbs) {
        return;
    }

    breadcrumb.breadcrumbs = new Breadcrumbs(breadcrumb);
}

_breadcrumbs();
